import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  checkoutNavigationBar: {
    flex: 'auto',
    flexGrow: 1,
    margin: '-15px -15px 20px',
    maxWidth: 'none',
    [theme.breakpoints.up('sm')]: {
      border: '1px solid #e5e5e5',
      borderBottom: 'none',
      borderRadius: '4px',
      margin: '0 0 50px',
      maxWidth: '100%',
    },
  },
  currentOrCompletedCheckoutTab: {
    fontWeight: 'bold',
    // Material UI 'dims' inactive tabs via an opacity value not color so it needs to
    // be overridden to match that of the selected tab:
    opacity: 1,
    // Account for the 2px border-bottom applied to these tabs so text lines up with
    // the inactive tabs:
    paddingTop: '8px',
  },
  tabRoot: {
    borderBottom: '1px solid #e5e5e5',
    fontSize: '0.75rem',
    minWidth: '0',
    padding: '6px 0 6px',
    '&$currentOrCompletedCheckoutTab': {
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
    [theme.breakpoints.up('sm')]: {
      '&:first-child': {
        borderBottomLeftRadius: '3px',
      },
      '&:last-child': {
        borderBottomRightRadius: '3px',
      },
    },
  },
  tabIndicator: {
    [theme.breakpoints.up('sm')]: {
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px',
    },
  },
}))
